import axios from 'axios';
import { User } from '../../models/user';
import APIS from '../apiUrl';
import { requireAuthHeaders } from '../auth/getAuthToken';

interface UpdateUserRequest {
  /** The role to assign to the user. */
  role: number;
}

export const updateUser = async (userId: string, request: UpdateUserRequest): Promise<void> => {
  await axios.patch<User>(`${APIS.PORTAL_API}/api/v2/users/${userId}`, request, {
    headers: await requireAuthHeaders(),
  });
};
